import React from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

interface Props {
  open: boolean
  email?: string | null
  onClose: () => void
  onConfirm: () => void
}

const PasswordResetConfirmDialog: React.FC<Props> = ({ open, email, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Change Password</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {email
          ? `We'll send a password reset link to ${email}. Do you want to continue?`
          : "We'll send you a password reset link. Do you want to continue?"}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onConfirm} variant="contained">
        Send Reset Email
      </Button>
    </DialogActions>
  </Dialog>
)

export default PasswordResetConfirmDialog
